import React from "react";
import bellIconMobile from "../../../Assets/mobile-bellicon.svg";
import bellIcon from "../../../Assets/bellicon.png";
import Button from "@mui/material/Button";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import logout from "../../../Assets/logouthead.png";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import Menu from "@mui/material/Menu";
import { alpha } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import archive from "../../../Assets/archivehead.png";
import { Link, useNavigate } from "react-router-dom";
import cellphone from "../../../Assets/cellphone.svg";
import nobell from "../../../Assets/no-bell.svg";
import JobsLogo from "../../../Assets/JobsOhioLogo.jpeg";
const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});
const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
const MHeader = ({
  setNotification,
  notification,
  notificationsData,
  dropdownRef,
  handleNotificationNavigate,
  getAuthData,
  openLogout,
  handleMenuClick,
  loggingOut,
  handleMenuClose,
  anchorEl,
  goToArchive,
  setNotificationPreferenceModal,
}) => {

  const navigate = useNavigate();
  return (
    <DrawerHeader style={{
      position: "fixed",
      width: "100%",
      background: "#ffffff",
      // top: 30,
      zIndex: 999
    }}>
      <div className="inner-hearder-mobile">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Link
            to={"/dashboard"}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={JobsLogo}
              alt="logo"
              className="logo-image-of-the-project"
            />
          </Link>
        </div>
        <div className="bellicon-profileimage">
          <div
            className="bellicon-pos"
            onClick={() => setNotification(!notification)}
          >
            <div>
              <img
                src={bellIconMobile}
                alt="logo"
                className="bellicon-image"
              />
              <span className="notification-count">
                {notificationsData?.filter((item) => !item?.isStatus)
                  ?.length
                  ? notificationsData?.filter((item) => !item?.isStatus)
                    ?.length
                  : 0}
              </span>
            </div>
            {notification && (
              <div ref={dropdownRef} className="bell-icon-box">
                {notificationsData?.filter((item) => !item?.isStatus)
                  ?.length > 0 ? (
                  notificationsData
                    .filter((item) => !item?.isStatus)
                    .sort((a, b) => {
                      return (
                        new Date(b?.timestamp) - new Date(a?.timestamp)
                      );
                    })
                    .map((item, index) => (
                      <div
                        key={index}
                        className="bellicons-notification-container"
                      >
                        {/* <div className={item?.isRead === "true" ? "bell-icon-outer" : "bell-icon-outer-false"}> */}
                        <div
                          className={
                            item?.isStatus
                              ? "bell-icon-outer"
                              : "bell-icon-outer-false"
                          }
                        >
                          <div
                            className="bell-icon-container-inner"
                            onClick={() => handleNotificationNavigate(item)}
                          >
                            <img
                              src={bellIcon}
                              alt="logo"
                              className="bellicon-image"
                            />
                          </div>
                          <div
                            className="bellicon-text"
                            onClick={() => handleNotificationNavigate(item)}
                          >
                            <p className="bellicon-p">{item.title}</p>
                            <p className="bellicon-p2">{item.message}</p>
                          </div>
                          {/* <div>
                              <CloseIcon
                                className="bellicon-cross"
                                onClick={() => updateNotification(item?.id)}
                              />
                            </div> */}
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    ))
                ) : (
                  <p className="bellicon-p2-notfound">
                    No notifications found.
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="image-and-information">
            <div className="header-user-name-mobile">
              <p className="letter-heading">
                {getAuthData?.user?.profile?.firstName?.charAt(0)}
                {getAuthData?.user?.profile?.lastName?.charAt(0)}
              </p>
            </div>
            {/* <img src={userprofile} alt="logo" className="userprofile-image" /> */}
            <div className="username-and-role">
              <p className="user-name-header">
                {`${getAuthData?.user?.profile?.firstName} ${getAuthData?.user?.profile?.lastName}`}
              </p>
              {/* <p className="user-name-header-designation">Designation</p> */}
            </div>
          </div>
          <div className="Leades-filter-inner-container-header-mobile">
            <Button
              style={{ textTransform: "none" }}
              id="action-button"
              aria-controls={openLogout ? "action-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openLogout ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleMenuClick}
              endIcon={
                <ExpandMoreOutlinedIcon className="down-arrow-header" />
              }
            ></Button>
            <StyledMenu
              className="custom-menu"
              id="action-menu"
              MenuListProps={{
                "aria-labelledby": "action-button",
              }}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <div>
                {/* <MenuItem
                  className="AI-Leads-button-drop-down-up-header"
                  onClick={handleMenuClose}
                  disableRipple
                >
                  <p
                    className="push-to-slaesforce-in-button"
                    // onClick={() => loggingOut()}
                    onClick={goToArchive}
                  >
                    <span className="head-drop-menu">
                      <img src={archive} alt="archive" />
                    </span>
                    Archived Records
                  </p>
                </MenuItem> */}
                <MenuItem
                  className="AI-Leads-button-drop-down-up-header"
                  onClick={handleMenuClose}
                  disableRipple
                >
                  <p
                    className="push-to-slaesforce-in-button"
                    // onClick={() => loggingOut()}
                    onClick={() => navigate("/contactus")}
                  >
                    <span className="head-drop-menu">
                      {" "}
                      <img src={cellphone} alt="" />
                    </span>
                    Contact us
                  </p>
                </MenuItem>
                <MenuItem
                  className="AI-Leads-button-drop-down-up-header"
                  onClick={handleMenuClose}
                  disableRipple
                >
                  <p
                    className="push-to-slaesforce-in-button"
                    // onClick={() => loggingOut()}
                    onClick={() => setNotificationPreferenceModal(true)}
                  >
                    <span className="head-drop-menu">
                      {" "}
                      <img src={nobell} alt="" />
                    </span>
                    Notification Preferences
                  </p>
                </MenuItem>
                <MenuItem
                  className="AI-Leads-button-drop-down-up-header"
                  onClick={handleMenuClose}
                  disableRipple
                >
                  <p
                    className="push-to-slaesforce-in-button"
                    onClick={() => loggingOut()}
                  >
                    <span className="head-drop-menu">
                      <img src={logout} alt="logout" />
                    </span>
                    Logout
                  </p>
                </MenuItem>
              </div>
            </StyledMenu>
          </div>
        </div>
      </div>
    </DrawerHeader>
  );
};
export default MHeader;